import { Box, Grid2, Typography, useTheme } from "@mui/material";
import React from "react";
import PageTitle from "../../../components/Common/PageTitle";
import { clinicData } from "../../../assets/data/data";
import ResourcesCard from "../../../components/Content/ResourcesCard";

const Clinic = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <PageTitle
        title={"IPHC Clinic"}
        text={
          "The Interpersonal Hypnotherapy Clinics (IPHC) connect the public with qualified graduates of the Institute of Interpersonal Hypnotherapy who are active members of the IAIH in good standing. These clinics provide practitioners with the following resources:"
        }
        noIcon
      />
      <Grid2 container spacing={2} sx={{ mt: 4 }}>
        {clinicData.map((item) => (
          <ResourcesCard
            key={item.id}
            title={item.title}
            link={item.link}
            bigB
          />
        ))}
      </Grid2>

      <Typography sx={[theme.body, { mt: 4 }]}>
        These tools are designed to help practitioners build successful
        practices and deliver exceptional services to their clients.
      </Typography>
    </Box>
  );
};

export default Clinic;
